module.exports = __webpack_public_path__ + "img/coupon@3x.729919b1.png";